module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('b-button', {
    staticClass: "ml-2",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "xs",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.SendMailAlert
    }
  }, [_vm._v("Send Email")]), _vm._v(" "), _c('b-modal', {
    ref: "Agent_Coloder-modal",
    attrs: {
      "id": "Agent_Coloder-modal",
      "title": "Send Email",
      "size": "xl",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "9"
    }
  }, [_c('label', [_vm._v("To"), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "to",
      "name": "to"
    },
    model: {
      value: (_vm.agentForm.to),
      callback: function($$v) {
        _vm.$set(_vm.agentForm, "to", $$v)
      },
      expression: "agentForm.to"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-button', {
    staticClass: "mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "info",
      "size": "xs"
    },
    on: {
      "click": function($event) {
        _vm.showEmailIDDet(_vm.agentForm, _vm.agentForm.mailTypeVal)
      }
    }
  }, [_vm._v(_vm._s(_vm.agentForm.mailTypeVal == "previouscc" ?
    "CC" :
    (_vm.agentForm.mailTypeVal == "previousbcc" ?
      "BCC" :
      _vm.agentForm.mailTypeVal == "previousto" ?
      "To" :
      "To") + " Email IDs"))]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.TypeOfMailList,
      "option-value": "mailTypeVal",
      "option-text": "mailTypeTxt",
      "placeholder": "Select Type"
    },
    on: {
      "input": function($event) {
        _vm.getEmailType(_vm.agentForm.mailTypeVal)
      }
    },
    model: {
      value: (_vm.agentForm.mailTypeVal),
      callback: function($$v) {
        _vm.$set(_vm.agentForm, "mailTypeVal", $$v)
      },
      expression: "agentForm.mailTypeVal"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v("CC"), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "cc",
      "name": "cc"
    },
    model: {
      value: (_vm.agentForm.cc),
      callback: function($$v) {
        _vm.$set(_vm.agentForm, "cc", $$v)
      },
      expression: "agentForm.cc"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v("\n          BCC\n          "), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "bcc",
      "name": "bcc"
    },
    model: {
      value: (_vm.agentForm.bcc),
      callback: function($$v) {
        _vm.$set(_vm.agentForm, "bcc", $$v)
      },
      expression: "agentForm.bcc"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v("\n          Subject\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "subject",
      "name": "subject"
    },
    model: {
      value: (_vm.agentForm.subject),
      callback: function($$v) {
        _vm.$set(_vm.agentForm, "subject", $$v)
      },
      expression: "agentForm.subject"
    }
  }), _vm._v(" "), (!_vm.agentForm.subject) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMailDetails.subject))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v("\n          Body\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]), _vm._v(" "), _c('quill-editor', {
    staticStyle: {
      "width": "100% !important",
      "height": "300px !important",
      "background": "#fff",
      "display": "inline-block"
    },
    model: {
      value: (_vm.agentForm.mailbody),
      callback: function($$v) {
        _vm.$set(_vm.agentForm, "mailbody", $$v)
      },
      expression: "agentForm.mailbody"
    }
  })], 1), _vm._v(" "), (!_vm.agentForm.mailbody) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMailDetails.mailbody))]) : _vm._e()]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v("\n          Doc\n          "), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('Single-Upload', {
    attrs: {
      "disabled": _vm.agentColoder_inputFlag,
      "documentName": 'agentForm_mail_doc_',
      "otherDocName": 'agentForm_mail_doc_',
      "folderName": 'Console_Booking_Doc',
      "accept": '*',
      "assign_no": "Console_Booking_Doc",
      "multiple": true,
      "state": Boolean(_vm.agentForm.doc),
      "fileAllModuleId": _vm.agentForm.subject
    },
    model: {
      value: (_vm.agentForm.doc),
      callback: function($$v) {
        _vm.$set(_vm.agentForm, "doc", $$v)
      },
      expression: "agentForm.doc"
    }
  }), _vm._v(" "), (
    _vm.agentForm.doc != '' && _vm.agentForm.doc != undefined && _vm.agentForm.doc != null
  ) ? _c('span', [(_vm.agentForm.doc.split(',').length > 0) ? _c('b', _vm._l((_vm.sanitizedArray(_vm.agentForm.doc.split(','))), function(item_doc, index_doc) {
    return _c('span', {
      key: index_doc
    }, [(item_doc != '') ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.ViewDocFile(item_doc)
        }
      }
    }, [_vm._v("View Document - " + _vm._s(index_doc + 1))]) : _vm._e(), _vm._v(" "), _c('br')])
  })) : _c('b', [(
    _vm.agentForm.doc != '' &&
    _vm.agentForm.doc != undefined &&
    _vm.agentForm.doc != null
  ) ? _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.ViewDocFile(_vm.agentForm.doc)
      }
    }
  }, [_vm._v("View Document")]) : _vm._e()])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right ml-2 mt-2",
    attrs: {
      "disabled": _vm.agentForm.sendMail,
      "variant": "success"
    },
    on: {
      "click": _vm.SendMail
    }
  }, [_vm._v("Send\n      "), (_vm.agentForm.sendMail) ? _c('md-spinner', {
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right mt-2",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.HideModalAgent
    }
  }, [_vm._v("\n      Close")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "EmailIDS-modal",
    attrs: {
      "id": "EmailIDS-modal",
      "title": _vm.agentForm.mailTypeVal == 'previouscc' ?
        'CC' :
        (_vm.agentForm.mailTypeVal == 'previousbcc' ?
          'BCC' :
          _vm.agentForm.mailTypeVal == 'previousto' ?
          'To' :
          'To') + ' Email IDs',
      "size": "xl",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.agentForm.mailTypeVal == "previouscc" ?
    "CC" :
    _vm.agentForm.mailTypeVal == "previousbcc" ?
    "BCC" :
    _vm.agentForm.mailTypeVal == "previousto" ?
    "To" :
    "To"))]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input",
      "required": ""
    },
    model: {
      value: (_vm.agentForm[_vm.agentForm.mailTypeVal]),
      callback: function($$v) {
        _vm.$set(_vm.agentForm, _vm.agentForm.mailTypeVal, $$v)
      },
      expression: "agentForm[agentForm.mailTypeVal]"
    }
  }), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right mt-2",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "xs",
      "variant": "danger"
    },
    on: {
      "click": _vm.HideModalEmailIDS
    }
  }, [_vm._v("\n          Close")])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "sendMailPop",
    attrs: {
      "md-title": _vm.alert.title,
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.ShowModalAgentColoder
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fa2c9ea","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/sendEmail.vue
// module id = 2737
// module chunks = 0